module.exports = estDateFilter;

/*@ngInject*/
function estDateFilter($filter) {
    return function (date) {
        if (!_.isDate(date)) return '';
        return $filter('date')(date, 'dd.MM.yyyy');
    };
}



/** WEBPACK FOOTER **
 ** ./app/shared/filters/estdate.filter.js
 **/